module.exports = __webpack_public_path__ + "static/media/Fir St, South San Francisco, CA2.a6677d44.jpg";